import { BehaviorSubject } from 'rxjs';
import { SocketConnectionState } from '../models/socket';

export abstract class WebsocketFallbackService {
  public socketConnectionState = new BehaviorSubject<SocketConnectionState>(
    SocketConnectionState.initialization,
  );

  abstract reloadAccounts(): void;
  abstract reloadStatus(): void;
  abstract reloadUser(): void;
}
